import React from 'react';
import {
	Grid,
	makeStyles,
	Card,
	CardContent,
	Typography,
	Divider
} from '@material-ui/core';
import WebsiteInfo from './WebsiteInfo';
import ContentAnalysis from './ContentAnalysis';
import PagesAccordion from './PagesAccordion';
import AIAnalysis from './AIAnalysis';
import SummaryCard from './SummaryCard';

const useStyles = makeStyles((theme) => ({
	resultsContainer: {
		marginTop: theme.spacing(3),
	},
	sectionTitle: {
		marginBottom: theme.spacing(2),
		color: theme.palette.primary.main,
		fontWeight: 'bold',
	},
	card: {
		marginBottom: theme.spacing(2),
	},
}));

const WebcrawlResults = ({ data }) => {
	const classes = useStyles();

	if (!data) {
		return null;
	}

	return (
		<div className={classes.resultsContainer}>
			<Typography variant="h4" className={classes.sectionTitle}>
				Analysis Results
			</Typography>
			
			<Grid container spacing={3}>
				{/* Website Information */}
				<Grid item xs={12}>
					<WebsiteInfo website={data.website} />
				</Grid>

				{/* Content Analysis */}
				<Grid item xs={12} md={6}>
					<ContentAnalysis contentAnalysis={data.contentAnalysis} />
				</Grid>

				{/* Summary */}
				<Grid item xs={12} md={6}>
					<SummaryCard summary={data.summary} />
				</Grid>

				{/* Full AI Analysis Overview (overall analysis from crawl) */}
				{(data.overallAiAnalysis || data.aiAnalysis) && (
					<Grid item xs={12}>
						<AIAnalysis aiAnalysis={data.overallAiAnalysis || data.aiAnalysis} />
					</Grid>
				)}

				{/* Pages */}
				<Grid item xs={12}>
					<PagesAccordion pages={data.pages} />
				</Grid>
			</Grid>
		</div>
	);
};

export default WebcrawlResults;
